import { z } from 'zod';

import type { FilesValue } from '@/components/forms/files';

/** Valeurs du formulaire « Ma garantie mobilité ». */
export interface GarantieMobiliteValues {
    circonstances: string;
    files: FilesValue;
}

/** Contrôle de la garantie mobilité (ancien `GarantieMobilite/validate.js`). */
export const garantieMobiliteSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Partial<GarantieMobiliteValues>;
    const errors: Record<string, string> = {};

    if (!v.circonstances) {
        errors.circonstances = 'Le champ est obligatoire';
    }

    /* Le back limite circonstances à 120 caractères : on garde la contrainte côté front
       pour éviter un 422 sur un motif "Autres motifs" saisi librement à l'avenir. */
    if (v.circonstances && v.circonstances.length > 120) {
        errors.circonstances = 'Le motif ne peut pas dépasser 120 caractères';
    }

    if (!v.files?.X) {
        errors.files = 'Le justificatif est obligatoire';
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
